module.exports = __webpack_public_path__ + "img/andar-bahar.b8bfe23.webp";